const timestampInitial = Date.now();

function _requestAnimationFrame(f) {
  const timestampCurrent = Date.now();
  const diff = timestampCurrent - timestampInitial;

  return setTimeout(f, 1000 / 60, diff);
}

function _cancelAnimationFrame(requestID) {
  clearTimeout(requestID);
}

const register = (win: any) => {
  win.requestAnimationFrame =
    win.requestAnimationFrame ||
    win.mozRequestAnimationFrame ||
    win.webkitRequestAnimationFrame ||
    win.msRequestAnimationFrame ||
    win.oRequestAnimationFrame ||
    _requestAnimationFrame;

  win.cancelAnimationFrame =
    win.cancelAnimationFrame ||
    win.mozCancelAnimationFrame ||
    win.webkitCancelAnimationFrame ||
    win.msCancelAnimationFrame ||
    win.oCancelAnimationFrame ||
    _cancelAnimationFrame;

  const userAgent = win.navigator.userAgent.toLowerCase();
  if (/iphone|ipod|ipad|mac|ios/.test(userAgent)) {
    win.requestAnimationFrame = _requestAnimationFrame;
    win.cancelAnimationFrame = _cancelAnimationFrame;
  }
};

if ('undefined' !== typeof window) {
  register(window);
}

export {};
